(ns practitest.frontend.components2.components-provider
  (:require
   [practitest.frontend.pt-ts-bridge :refer [ComponentsProvider IconsProvider]]
   [practitest.frontend.components.selector :refer [new-select]]
   [practitest.frontend.components2.icons-list :refer [exported-icons]]
   [practitest.frontend.components2.search-box :as search-box]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.components2.dropdown :refer [DropdownMenu
                                                     DropdownMenuBody
                                                     DropdownMenuItem]]
   [reagent.core :as reagent]))


(defn components-provider
  [& children]
  (into [:r>
         ComponentsProvider
         #js {:value
              ;; TODO: auto-registration of components
              #js {:MuxSpinner (reagent/reactify-component spinners/mux-spinner)
                   :SearchBox (reagent/reactify-component search-box/search-textbox)
                   :DropdownMenu DropdownMenu
                   :DropdownMenuBody DropdownMenuBody
                   :DropdownMenuItem DropdownMenuItem
                   :Select2 (reagent/reactify-component new-select)}}]
        children))

(defn icons-provider
  [child]
  [:r> IconsProvider #js {:value exported-icons} child])

(defn application-provider
  [child]
  [icons-provider
   [components-provider
    child]])

(def ^:export ApplicationProvider
  (fn [props] 
    (reagent/as-element
     [application-provider (.-children props)])))